import { parseName } from "@certn/utils";

import { Avatar } from "../../avatar/Avatar";
import { SelectChip } from "../../chips/select-chip/SelectChip";
import { PickerItem, TriggerProps } from "../types";

export function AvatarTrigger<T extends PickerItem>(props: TriggerProps<T>) {
  if (props.selectedItems.length === 1) {
    return (
      <SelectChip
        avatar={
          <Avatar
            name={parseName(props.selectedItems[0].name)}
            image={props.selectedItems[0].image}
            size="x-small"
          />
        }
        isSelected
        testID={props.testID}
        isDisabled={props.isDisabled}
      >
        {props.selectedItems[0].name}
      </SelectChip>
    );
  }

  return (
    <SelectChip
      icon={props.icon}
      badge={props.count}
      testID={props.testID}
      isDisabled={props.isDisabled}
    >
      {props.label}
    </SelectChip>
  );
}
